import {
    Box, chakra, Button, Input
} from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../../../components/modal-wrapper';

export const ProfilePictureModalWrapper = chakra(ModalWrapper, {
    baseStyle: {
        justifyContent: 'flex-start',
        flexDirection: 'column',
        w: '30%',
        h: 'calc(100% - 70px)',
        overflow: 'auto',
        maxHeight: '470px'
    }
});

export const Title = chakra(Box, {
    baseStyle: {
        fontSize: '25px',
        fontWeight: '500',
        color: 'neutral.600',
        marginBottom: '5px'
    }
});

export const Header = chakra(Box, {
    baseStyle: {
        fontSize: '18px',
        w: '100%',
        display: 'flex',
        justifyContent: 'flex-end'
    }
});

export const Close = chakra(Button, { baseStyle: { fontSize: '18px' } });

export const ImageDragAndDrop = chakra(Box, {
    baseStyle: {
        w: '200px',
        h: '200px',
        fontSize: '14px',
        borderRadius: '100px',
        border: '1px dashed var(--3p-colors-neutral-700)',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        margin: '15px'
    }
});

export const UploadPhotoButton = chakra(Button, {
    baseStyle: {
        w: '200px',
        h: '60px',
        borderRadius: '30px',
        fontSize: '18px',
        fontWeight: 300,
        backgroundColor: 'neutral.400'
    }
});

export const Footer = chakra(Box, {
    baseStyle: {
        w: '100%',
        display: 'flex',
        justifyContent: 'flex-end'
    }
});

export const HiddenFileInput = chakra(Input, { baseStyle: { display: 'none' } });

export const Wrapper = chakra(Box, {
    baseStyle: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        w: '100%'
    }
});

export const ButtonsDivider = chakra(Box, {
    baseStyle: {
        fontSize: '17px',
        marginBottom: '5px'
    }
});
